import React, { useCallback, useState } from 'react';
import { debounce, noop } from 'lodash';
import { translate } from '@fiverr-private/i18n-react';
import { FIELD_TYPES, VARIATIONS_TOOLBAR_FIELD_DEBOUNCE } from '../../../../shared/constants';
import { TEXT_FIELDS } from '../propTypes/listings';
import DesktopToolbar from './ToolBar';

const inputProps = {
    autoComplete: 'off',
    'data-lpignore': true,
};

/**
 * A component which would render controls to fill brand name and slogan. View depends on if the device is mobile.
 * @param {String} brandName
 * @param {String} slogan
 * @param {Function} onChange
 */
export const TextFields = ({ brandName = '', slogan = '', onChange = noop }) => {
    const [brandNameValue, setBrandNameValue] = useState(brandName);
    const [sloganValue, setSloganValue] = useState(slogan);
    const [brandNameError, setBrandNameError] = useState();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedChange = useCallback(
        debounce((change, label) => {
            onChange(change, label);
        }, VARIATIONS_TOOLBAR_FIELD_DEBOUNCE),
        []
    );

    const onBrandNameChange =
        (shouldApply = true) =>
        (value, label) => {
            const isValid = !!value && value.length > 0;
            const error = !isValid ? translate('logo_maker_perseus.buyer.listing.missing_brand_name') : undefined;

            setBrandNameError(error);
            setBrandNameValue(value);

            if (isValid && shouldApply) {
                debouncedChange({ brandName: value, slogan }, { type: FIELD_TYPES.BRAND_NAME, label });
            }
        };

    const onSloganChange =
        (shouldApply = true) =>
        (value, label) => {
            setSloganValue(value);
            shouldApply && debouncedChange({ slogan: value, brandName }, { type: FIELD_TYPES.SLOGAN, label });
        };

    return (
        <DesktopToolbar
            brandName={brandNameValue}
            slogan={sloganValue}
            inputProps={inputProps}
            brandNameError={brandNameError}
            onBrandNameChange={onBrandNameChange(true)}
            onSloganChange={onSloganChange(true)}
        />
    );
};

TextFields.propTypes = TEXT_FIELDS;

export default TextFields;
